import React from "react";
import AlipayIcon from '../../../assets/svg/alipay.svg';
import FrameBlockResult from '../FrameBlockResult'
import { ApmsTypes } from "../../../constants";

const AlipayCNResult = ({ link }) => {
    return (
        <FrameBlockResult link={link} apmType={ApmsTypes.AlipayCN} icon={AlipayIcon} />
    )
}

export default AlipayCNResult;